<template>
  <div style="margin:20px">
    <FiPageRail title="Actuals - Billing Report"/>
    <div style="position: relative; font-weight: bold; font-size: 24px" class="align-right d-flex align-items-center justify-content-center">
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"></date-picker>&nbsp;&nbsp;
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(1)">></a>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
      <b-button v-on:click.prevent="load_data()" :disabled="loading">Run Report</b-button>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
      Time Diff &nbsp;<b-form-select v-model="time_threshold" :options="threshold_options" style="font-size: 20px; font-weight: bold; width:110px"/>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
      Mileage Diff &nbsp;<b-form-select v-model="miles_threshold" :options="threshold_options" style="font-size: 20px; font-weight: bold; width:110px"/>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
      Filter Results&nbsp;<b-form-input style="width: 200px" v-model="booking_filter" placeholder="charterID,vehicle,driver"/>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;

      <div class="d-flex align-items-center justify-content-center">
        <b-button size="md" variant="success" @click="download">Download</b-button>
      </div>
    </div>

    <div v-if="!loading">
      <div class="row" style="margin:30px; font-weight: bold; font-size: 24px;">
        <div class="col" style="border: 1px solid grey;">{{items.length}} of {{summary.total_cnt}}</div>
        <div @click="filter_by_type('contract')" class="col contract" :style="selected_type=='contract' ? 'margin-left:15px; border: 2px solid red;' : 'margin-left:15px; border: 1px solid grey;'">Contract: {{summary.contract_cnt}}</div>
        <div @click="filter_by_type('private')" class="col private" :style="selected_type=='private' ? 'border: 2px solid red;' : 'border: 1px solid grey;'">Private: {{summary.private_cnt}}</div>
      </div>
    </div>

    <table v-if="!loading" width="100%" border="1" cellpadding="2">
      <tr>
        <th colspan="9" style="font-size: 18px; font-weight: bold;">&nbsp;</th>
        <th style="background-color: lightgrey" colspan="3" v-for="time_field in summary.time_fields" @click="sort_dates('planned' + time_field + 'DateTime')">{{time_field}}</th>
        <th>&nbsp;</th>
      </tr>
      <tr>
<!--        <th width="60px" @click="sort_strings('booking_type')">Type</th>-->
        <th width="60px" @click="sort_numbers('charterID')">CharterID</th>
        <th width="60px" @click="sort_numbers('movementID')">MvmtID</th>
        <th width="60px" @click="sort_strings('vehicle')">Vehicle</th>
        <th width="60px" @click="sort_strings('driver')">Driver</th>
        <th width="60px" @click="sort_strings('is_one_way')">Is One Way</th>
        <th width="60px" @click="sort_strings('clientID')">ClientID</th>
        <th width="60px" @click="sort_numbers('plannedDistance')">Planned Mileage</th>
        <th width="60px" @click="sort_numbers('actualTotalDistance')">Actual Mileage</th>
        <th width="60px" @click="sort_numbers('diffTotalDistance')">Mileage Diff</th>

<!--        <th width="60px" @click="sort_numbers('plannedTotalDuration')">Planned Duration</th>-->
<!--        <th width="60px" @click="sort_numbers('actualTotalDuration')">Actual Duration</th>-->
<!--        <th width="60px" @click="sort_numbers('durationDelta')">Duration Diff</th>-->
        <template v-for="time_field in summary.time_fields">
          <th width="60px" @click="sort_dates('planned' + time_field + 'DateTime')">Planned</th>
          <th width="60px" @click="sort_dates('actual' + time_field + 'DateTime')">Actual</th>
          <th width="30px" @click="sort_numbers(time_field + 'Delta')">Diff</th>
        </template>
        <th width="200px" @click="sort_strings('notes')">Billing Notes</th>
      </tr>
      <template v-for="item in items">
        <tr>
<!--          <td align="center">{{ item.booking_type }}</td>-->
          <td align="center">{{ item.charterID }}</td>
          <td align="center">
            <router-link style="font-weight: bold;" :to="{ path: '/actuals?booking_id=' + item.booking_hash }">{{ item.movementID }}</router-link>
          </td>
          <td align="center">{{ item.vehicle }}</td>
          <td align="center">{{ item.driver }}</td>
          <td align="center">{{ item.is_one_way }}</td>
          <td align="center">{{ item.clientID }}</td>
          <td align="center">{{ item.plannedDistance}}</td>
          <td align="center">{{ item.actualTotalDistance}}</td>
          <td align="center">{{ item.diffTotalDistance}}</td>
<!--          <td align="center">{{ item.plannedTotalDuration  | units('m')}}</td>-->
<!--          <td align="center" v-if="item.actualTotalDuration">{{ item.actualTotalDuration  | units('m')}}</td>-->
<!--          <td align="center" v-else></td>-->
<!--          <td align="center" v-if="item.durationDelta && item.durationDelta < 0" class="early-duration">{{ item.durationDelta  | units('m')}}</td>-->
<!--          <td align="center" v-else-if="item.durationDelta == 0">{{ item.durationDelta  | units('m')}}</td>-->
<!--          <td align="center" v-else-if="item.durationDelta" class="late-duration">{{ item.durationDelta  | units('m')}}</td>-->
<!--          <td align="center" v-else></td>-->
          <template v-for="time in item.times">
            <td>{{time.planned | formatDateTimeSmall}}</td>
            <td>{{time.actual | formatDateTimeSmall}}</td>
            <td v-if="time.actual && time.delta < 0 && Math.abs(time.delta) > 0" class="early">{{time.delta | units('m')}}</td>
            <td v-else-if="time.actual && time.delta > 0 && time.delta > 0" class="late">{{time.delta | units('m')}}</td>
            <td v-else-if="time.actual && time.delta == 0">{{time.delta | units('m')}}</td>
            <td v-else-if="time.delta">{{time.delta | units('m')}}</td>
            <td v-else>&nbsp;</td>
          </template>
          <td align="left"><b-form-input v-if="item.booking_hash" style="border: 1px solid black; min-width:200px" v-model="item.event_notes" v-on:blur="save_notes(item)" @keydown.enter.native="save_notes(item)"/></td>
        </tr>
      </template>
    </table>
    <div v-else>
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>
  </div>

</template>
<script>
import {api_url, get_actuals_billing_report, save_event_notes} from '../networking/apis'
import {mapState} from "vuex"
import {justDate} from '../helpers/dates'
import moment from 'moment'
import axios from "axios";

export default {
  name: 'actuals_billing_report',

  components: {
  },

  data() {
    return {
      booking_filter: '',
      items: [],
      ontime_items: [],
      early_items: [],
      late_items: [],
      summary: [],
      time_threshold: null,
      miles_threshold: null,
      selected_type: null,
      selected_status: null,
      threshold_options: [
        { value: null, text: 'All' },
        { value: '10', text: '> 10m' },
        { value: '15', text: '> 15m' },
        { value: '30', text: '> 30m' },
        { value: '45', text: '> 45m' },
        { value: '60', text: '> 60m' },
        { value: '120', text: '> 120m' },
      ],
      loading: false,
      details_fromDate: justDate(moment().subtract(1, 'days')),

      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(90, 'days'),
        maxDate: moment().add(90, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
      },
    }
  },
  created() {

  },
  methods: {
    async load_data() {
      this.loading = true
      try {
        const {value: {data = []}} = await get_actuals_billing_report(this.user.tenant, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.items_full = data.results
        this.filter_items()
      } catch(e){
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }
      this.loading = false
    },
    async save_notes(item) {
      try {
        let json = {
          'event_hash': item.event_notes_hash,
          'notes': item.event_notes
        }
        const {value: { data = [] } } = await save_event_notes(this.user.tenant, json)
      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }

    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    },
    filter_items() {
      this.items = this.items_full
      if (this.selected_type)
        this.items = this.items.filter(item => item.booking_type == this.selected_type)
      if (this.booking_filter)
        this.items = this.items.filter(item => (item.charterID.indexOf(this.booking_filter) != -1 || (item.driver != null && item.driver.indexOf(this.booking_filter) != -1) || (item.vehicle != null && item.vehicle.indexOf(this.booking_filter) != -1)))
      if (this.time_threshold)
        this.items = this.items.filter(item => (Math.abs(item.PickupDelta) > this.time_threshold || Math.abs(item.CompletedDelta) > this.time_threshold))
      if (this.miles_threshold)
        this.items = this.items.filter(item => (Math.abs(item.diffTotalDistance) > this.miles_threshold))
    },
    filter_by_type(type) {
      if (type == null || this.selected_type == type) {
        this.selected_type = null
      } else {
        this.selected_type = type
      }
      this.filter_items()
    },
    filter_by_status(status) {
      if (status == null || this.selected_status == status) {
        this.selected_status = null
      } else {
        this.selected_status = status
      }
      this.filter_items()
    },
    sort_dates(col) {
      console.log("sort_dates:" + col)
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          // console.log("sort:" + a[col] + ", " + b[col])

          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            return new Date(a[col]) - new Date(b[col])
          }
        })
      }
      this.sort_col = col
    },
    sort_numbers(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            return a[col] - b[col]
          }
        })
      }
      this.sort_col = col
    },
    sort_strings(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            let fa = a[col].charAt(0).toLowerCase(),
                fb = b[col].charAt(0).toLowerCase();

            if (fa < fb) {
              return -1;
            }
            if (fa > fb) {
              return 1;
            }
            return 0;
          }
        })
      }
      this.sort_col = col
    },
    async download(){
      this.$emit('showAlert', 'processing download request', 'info', 5000)
      axios.defaults.headers.common.Accept = {}
      axios.post(
          `${api_url}bookings/reports/actuals/billing/download`,
          {
            tenant: this.user.tenant,
            date: moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
          }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('jwt')}`,
              Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'blob'
          }
      ).then((response) => {
        axios.defaults.headers.common.Accept = 'application/json'
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
            'download',
            `billing-${this.user.tenant}-${this.details_fromDate}.csv`
        )
        document.body.appendChild(link)
        link.click()
        this.$emit('showAlert', 'download complete', 'success', 5000)
      }).catch(e => {
        axios.defaults.headers.common.Accept = 'application/json'
        this.$emit('showAlert', 'data could not be downloaded.', 'danger')
      })
    },
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
    },
    time_threshold(val) {
      this.filter_items()
    },
    miles_threshold(val) {
      this.filter_items()
    },
    booking_filter() {
      this.filter_items()
    },
  }
}
</script>

<style scoped>

tr:nth-child(even) {
  background-color: #f2f2f2 !important;
}
.arrows {font-size: 22px; font-weight: bold; color: var(--fi-rail-accent) !important }

.early-duration { background-color: hsla(120,100%,75%,0.2)}
.late-duration { background-color: rgba(255,0,0,0.2)}

.early { background-color: hsla(120,100%,75%,0.2)}
.late { background-color: rgba(255,0,0,0.2)}
.private { background-color: hsla(200,40%,80%,0.2) }
.contract { background-color: hsla(250,60%,70%,0.2) }

</style>
